export default __webpack_public_path__ + "static/banner-travel-destination-healthy-919fa928f4082f909d3a49729a2c52c8.webp";